import {
    ACTIVATIONS_AND_DEACTIVATIONS,
    ACTIVATIONS_AND_DEACTIVATIONS_ERROR,
    CLEAN_ACTIVATIONS_AND_DEACTIVATIONS,
    CLEAN_ACTIVATIONS_AND_DEACTIVATIONS_ERROR,
} from "_models/redux/types";

const initialState = {
    loaded: undefined,
    method: undefined,
    payload: undefined,
    status: undefined,
    state: undefined,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case ACTIVATIONS_AND_DEACTIVATIONS:
            return {
                ...state,
                loaded: true,
                method: action?.method || null,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "success",
            };

        case ACTIVATIONS_AND_DEACTIVATIONS_ERROR:
            return {
                ...state,
                loaded: true,
                payload: action?.payload || {},
                status: action?.status || null,
                state: "error",
            };

        case CLEAN_ACTIVATIONS_AND_DEACTIVATIONS:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "success",
            };

        case CLEAN_ACTIVATIONS_AND_DEACTIVATIONS_ERROR:
            return {
                ...state,
                loaded: false,
                payload: action?.payload || undefined,
                status: undefined,
                state: "error",
            };
        default:
            return state;
    }
}
